import * as ko from "knockout";

import { addBindingHandler } from "./util";


/**
 * Binding that enables the bound Pli button when the value is true.
 */
export interface PliEnableButtonBinding {
    update: (element: HTMLElement, valueAccessor: () => ko.MaybeSubscribable<any>) => void;
}


export function setButtonEnabledState(element: HTMLElement, enabled: boolean): void {
    ko.bindingHandlers.enable.update(element, () => enabled);
    ko.utils.toggleDomNodeCssClass(element.parentElement, "disabled", !enabled);
}


const pliEnableButtonBinding: PliEnableButtonBinding = {
    update: (element, valueAccessor) => {
        const enabled = ko.unwrap(valueAccessor());
        setButtonEnabledState(element, enabled);
    }
};


/**
 * Activates the 'pliEnableButton' binding.
 */
export function activatePliEnableButtonBinding(): PliEnableButtonBinding {
    return addBindingHandler("pliEnableButton", pliEnableButtonBinding);
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/knockout/pliEnableButton.ts